import React, { Component } from 'react';
import Axios from 'axios';
import { getCpaPreferences } from 'utilities/utils';
import { DESKTOP_APPS } from 'constants/constants';
import liscioLogoMediumPng from 'images/liscio_logo_medium.png';

export default class LisicoApps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appName: '',
    };
  }

  UNSAFE_componentWillMount() {
    const preferences = getCpaPreferences();
    if (preferences && preferences.liscio_app_name) {
      const liscioAppName = preferences.liscio_app_name;
      let appName;
      liscioAppName.map((ele) => {
        if (ele.key === 'Liscio Desktop') {
          appName = ele.label;
        }
        this.setState({
          appName,
        });
        return ele;
      });
    }
    const feed = `${DESKTOP_APPS}?version=1`;
    Axios.get(feed).then((res) => {
      const { data } = res.data;
      if (data && data.url) {
        const { version, url } = data;
        this.setState({
          version,
          url,
        });
      }
    });
  }

  handleDownload = () => {
    if (this.state.url) {
      window.location = this.state.url;
    }
  };

  render() {
    const { appName, version } = this.state;
    return (
      <div id="content">
        <div className="center-wrapper col m-auto">
          <div className="row">
            <div className="col-lg-4 col-sm-12 col-md-6">
              <div className="card mb-4 shadow-s">
                <div
                  className="card-img-top d-flex justify-content-center align-items-center"
                  style={{ height: '150px' }}
                >
                  <img
                    src={liscioLogoMediumPng}
                    alt="liscio_logo"
                    style={{ height: '75px' }}
                  />
                </div>
                <div className="card-body">
                  <h5 className="card-title">
                    {appName} {version}
                  </h5>
                  <button
                    type="button"
                    className="btn btn-primary col mt-3"
                    onClick={this.handleDownload}
                  >
                    Download
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
